/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-06-10 15:05:14
 * @LastEditors: linxi
 * @LastEditTime: 2021-07-30 20:09:16
 */
import React, { ReactElement, useEffect, useState } from "react";
import EChartsReact from "echarts-for-react";

export interface BasicType {
  name: string;
  value1: number;
  value2: number;
}
export interface BasicChartsProps {
  legendData?: string[];
  basicData?: BasicType[];
  style?: React.CSSProperties;
}

export const Basics: React.FC<BasicChartsProps> = ({
  basicData,
  style,
}): ReactElement => {
  const [option, setOption] = useState<any>();
  useEffect(() => {
    if (basicData) {
      const PieOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: "2%",
          right: "2%",
          bottom: 20,
          top: "5%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: basicData.map((v) => v.name),
          axisLabel: {
            interval: 0,
            width: 60,
            fontSize: 11,
            overflow: "truncate",
            textStyle: {
              color: "#ACE3FF", //坐标值得具体的颜色
            },
            formatter: function (params: string, index: number) {
              if (basicData.length <= 11) {
                return params;
              } else {
                if (index % 2 !== 0) {
                  return "\n\n" + params;
                } else {
                  return params;
                }
              }
            },
          },
        },
        yAxis: [
          {
            max: 100,
            // name: "占比（%）",
            type: "value",
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#2B326F"],
                width: 1,
                type: "solid",
              },
            },
            axisLabel: {
              textStyle: {
                color: "#ACE3FF", //坐标值得具体的颜色
              },
            },
          },
        ],
        series: [
          {
            name: "机构占比",
            type: "bar",
            stack: "对比",
            barWidth: 12,
            itemStyle: {
              //自定义颜色
              normal: { color: "#0033FF" },
            },
            emphasis: {
              focus: "series",
            },
            data: basicData.map((v) => v.value1),
          },
          {
            name: "接入机构数",
            type: "bar",
            stack: "对比",
            itemStyle: {
              //自定义颜色
              normal: { color: "#00E5FF" },
            },
            emphasis: {
              focus: "series",
            },
            data: basicData.map((v) => v.value2),
          },
        ],
      };
      setOption(PieOption);
    }
  }, [basicData]);
  return (
    <>
      {option && <EChartsReact option={option} style={style} notMerge={true} />}
    </>
  );
};
